import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceCreateEvidenceFieldSectionPayload } from 'api/actions/device-create-evidence-field-section/device-create-evidence-field-section-payload';
import { DeviceCreateEvidenceFieldSectionPathParameters } from 'api/actions/device-create-evidence-field-section/device-create-evidence-field-section-path-parameters';
import { DeviceCreateEvidenceFieldSectionResponse } from 'api/actions/device-create-evidence-field-section/device-create-evidence-field-section-response';

type DeviceCreateEvidenceFieldSectionQueryParameters = Record<string, any>;

/**
 * The path of the DeviceCreateEvidenceFieldSection action.
 */
export const deviceCreateEvidenceFieldSectionActionPath = new SweetPath<
  keyof DeviceCreateEvidenceFieldSectionPathParameters
>('/api/device/evidence-field-sections/create', { path: '{param}' });

/**
 * Creates a contextualized DeviceCreateEvidenceFieldSection actions.
 */
export default function createDeviceCreateEvidenceFieldSectionAction(axios: AxiosInstance) {
  return function deviceCreateEvidenceFieldSectionAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: DeviceCreateEvidenceFieldSectionQueryParameters;
    payload: DeviceCreateEvidenceFieldSectionPayload;
  }) {
    const path = deviceCreateEvidenceFieldSectionActionPath.original;

    return axios.request<DeviceCreateEvidenceFieldSectionResponse, DeviceCreateEvidenceFieldSectionResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
